import { render, staticRenderFns } from "./precisePost2.vue?vue&type=template&id=dd155334&scoped=true&"
import script from "./precisePost2.vue?vue&type=script&lang=js&"
export * from "./precisePost2.vue?vue&type=script&lang=js&"
import style0 from "./precisePost2.vue?vue&type=style&index=0&id=dd155334&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd155334",
  null
  
)

export default component.exports